import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import parse from 'html-react-parser'


const BOTCustomMetaTags = ({ metaOthers }) =>
  <Helmet>
    {parse(metaOthers)}
  </Helmet>

BOTCustomMetaTags.propTypes = {
  metaOthers: PropTypes.string
}

export default BOTCustomMetaTags
